import { useTranslation } from "react-i18next";
import React from 'react';
import {Button, Col, DatePicker, Form, FormInstance, Row, Typography} from "antd";
import FormItemDropdown from "../../../form-dropdown/FormItemDropdown";
import {DeleteOutlined, FilterOutlined} from "@ant-design/icons";
import './filter-form.scss'
import {useForm} from "antd/es/form/Form";
import {surveyMethodsFilter} from "../../../../pages/course-construction/survey-plan/constants/data";
import dayjs from 'dayjs';


type FilterFormProps = {
  showFilter?: boolean
  onFinish?: (values: any) => void;
  handleCloseFilter?: () => void;
  clearFilter: (form: FormInstance) => void;
  filterData?: any;
  dataOptions?: any
}


const dataOptionsStatus = [
  {
    name: 'Đang tiến hành',
    code: 'in_process',
  },
  {
    name: 'Chưa tiến hành',
    code: 'not_started',
  },
  {
    name: 'Hết hạn',
    code: 'finish'
  }
]


const FilterForm = ({showFilter, onFinish, clearFilter, filterData, dataOptions}: FilterFormProps) => {
  const { t } = useTranslation();
  const [form] = useForm()
  return (
    <div className={`wrapper-filter ${showFilter ? "open" : ""}`}>
        <Form form={form} name="filterForm" onFinish={onFinish}>
          <Row gutter={[{xs: 8, xl: 16, md: 16}, 8]}>
            <Col
              xl={{span: 5}}
              md={{span: 5}}
              sm={{span: 5}}
              xs={{span: 24}}
            >
              <Typography.Title level={5}>{t("Phương pháp khảo sát", "Phương pháp khảo sát")}</Typography.Title>
              <Form.Item name="surveyTarget">
                <FormItemDropdown
                  modeDropdown="multiple"
                  placeholder={t("Chọn phương pháp khảo sát", "Chọn phương pháp khảo sát")}
                  value={filterData?.surveyTarget}
                  options={surveyMethodsFilter}
                />
              </Form.Item>
            </Col>
            <Col xl={{span: 5}}
                 md={{span: 5}}
                 sm={{span: 5}}
                 xs={{span: 24}}>
              <Typography.Title level={5}>{t("Thời gian", "Thời gian")}</Typography.Title>

              <Form.Item name="rangeDate">

                <DatePicker.RangePicker
                  allowEmpty={[true, true]}
                  placeholder={[t("Bắt đầu", "Bắt đầu"), t("Kết thúc", "Kết thúc")]}
                  format='DD/MM/YYYY'
                />

              </Form.Item>
            </Col>
            <Col xl={{span: 5}}
                 md={{span: 5}}
                 sm={{span: 5}}
                 xs={{span: 24}}>
              <Typography.Title level={5}>{t("Đối tượng", "Đối tượng")}</Typography.Title>
              <Form.Item name="surveyObject">
                <FormItemDropdown
                  modeDropdown="multiple"
                  placeholder={t("Chọn đối tượng", "Chọn đối tượng")}
                  value={filterData?.surveyObject}
                  options={dataOptions?.dataSurveyObject}
                />
              </Form.Item>
            </Col>
            <Col xl={{span: 5}}
                 md={{span: 5}}
                 sm={{span: 5}}
                 xs={{span: 24}}>
              <Typography.Title level={5}>{t("Chọn trạng thái", "Chọn trạng thái")}</Typography.Title>
              <Form.Item name="statusSurveys">
                <FormItemDropdown
                  modeDropdown="multiple"
                  placeholder={t("Chọn trạng thái", "Chọn trạng thái")}
                  options={dataOptionsStatus}
                />
              </Form.Item>
            </Col>
            <Col
              xl={{span: 4}}
              md={{span: 4}}
              sm={{span: 4}}
              xs={{span: 24}}
              className="flex align-end"
            >
              <div className="group-btn--filter">
                <Button
                  className="btn btn-primary filter-btn"
                  htmlType="submit"
                >
                  <FilterOutlined/>
                  <Typography.Text>{t("Lọc", "Lọc")}</Typography.Text>
                </Button>
                <Button
                  className="btn btn-outlined clear-filter-btn"
                  onClick={() => clearFilter(form)}
                >
                  <DeleteOutlined/>
                  <Typography.Text>{t("Xóa bộ lọc", "Xóa bộ lọc")}</Typography.Text>
                </Button>
              </div>
            </Col>
          </Row>
        </Form>
      </div>
  );
};

export default FilterForm;